import React from 'react';
import '../ContactUs/ContactUs.scss';
import {graphql, useStaticQuery} from "gatsby";

const ContactUsContent=(props)=> {
    const contactUsContent = useStaticQuery(graphql`
    query contactUsContentQuery {
          strapiContactUs {
            AddressLine1
            PageName
            CompanyName
            Contact
            ContactHyperlink
          }
        }
      `);

 return( <div>
        <div className='contact'>{contactUsContent.strapiContactUs.PageName}</div>
        <div className='Sixt'>{contactUsContent.strapiContactUs.CompanyName}</div>
        <div className='address' >{contactUsContent.strapiContactUs.AddressLine1}</div>
        <div className='address' >Contact :<a href={contactUsContent.strapiContactUs.ContactHyperlink} style={{"color":"#FF5F00"}}> {contactUsContent.strapiContactUs.Contact}</a></div>
        </div>
       )
};
export default ContactUsContent;
